import { Tab, styled } from "@tm/components"

export const TinyTab = styled(Tab)(({ theme }) => ({
    minHeight: 36,
    fontSize: theme.typography.fontSize - 2,
    [theme.breakpoints.up("lg")]: {
        fontSize: theme.typography.fontSize - 2,
    },
}))
